export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/jerseys_sportswear.746fbe7.svg";